// import { UserIcon } from '../../helpers/icons';
import {
  darkenColor,
  getStringInitials,
  stringToColour,
} from '../../helpers/functions';

export const Avatar = ({ firstname = '', lastname = '', size = '35' }) => {
  const safeFirstname = firstname ?? '';
  const safeLastname = lastname ?? '';
  const nameColor = stringToColour(`${safeFirstname} ${safeLastname}`);
  const lightenNameColor = darkenColor(nameColor, 85);

  return (
    <div className="btn--icon">
      <span
        className={`d--flex radius--full align-items--center justify-content--center w-max--${size} w-min--${size} h-max--${size} h-min--${size}`}
        style={{
          fontWeight: 600,
          color: nameColor,
          backgroundColor: lightenNameColor,
        }}
      >
        {getStringInitials(safeFirstname)}
        {safeLastname.length > 0 && getStringInitials(safeLastname)}
      </span>
    </div>
  );
};
